import axios from 'axios';
import {
  CoursesSearchResponse,
  CourseSearchPageParams,
  UpdateCourseAttributesRequest,
} from '../interfaces/CoursesInterface';
import { mergeSavePayload } from '../utils/courseMappingChanges';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const serializeCourseParams = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, String(item));
        }
      });
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};

const searchCourses = async (eoaId: string, access_token: string, params: CourseSearchPageParams) =>
  axios.get<CoursesSearchResponse>(`${BASE_URL}/eoa/${eoaId}/courses`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
    params,
    paramsSerializer: serializeCourseParams,
  });

export const fetchCoursesPage = async (eoaId: string, access_token: string, params: CourseSearchPageParams) => {
  const response = await searchCourses(eoaId, access_token, params);
  return response.data;
};

export const getAcademicPeriods = async (eoaId: string, access_token: string) => {
  const response = await axios.get<string[]>(`${BASE_URL}/eoa/${eoaId}/academic-periods`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
  return response.data;
};

export const saveCourseMappingChanges = async (
  eoaId: string,
  access_token: string,
  updates: UpdateCourseAttributesRequest[]
) => {
  const mergedUpdates = mergeSavePayload(updates);

  for (const body of mergedUpdates) {
    await axios.patch(`${BASE_URL}/eoa/${eoaId}/courses/attributes`, body, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
};
